// HOAD: selo de nota (estrelas + quantidade) somando as cores da família.
// O selo nativo do Judge.me conta só as avaliações DESTA cor; aqui a nota e a
// contagem vêm de todas as cores do produto (23/09, pedido do André). Se a busca
// falhar ou não houver avaliação, o selo nativo continua visível (nada some).
(function () {
  function estrelas(media) {
    var n = Math.round(media);
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<svg viewBox="0 0 20 20" width="13" height="13" aria-hidden="true" style="fill:' + (i <= n ? '#e8a900' : '#d9d9d4') + '"><path d="M10 1l2.6 5.9 6.4.6-4.8 4.3 1.4 6.2L10 14.9 4.4 18l1.4-6.2L1 7.5l6.4-.6z"/></svg>';
    }
    return out;
  }

  function init(el) {
    if (!window.HoadReviewsFamilia) return;
    window.HoadReviewsFamilia.buscar(el.dataset.productIds, 50).then(function (reviews) {
      var notas = reviews.map(function (r) { return Number(r.rating) || 0; }).filter(Boolean);
      if (!notas.length) return;
      var media = notas.reduce(function (a, b) { return a + b; }, 0) / notas.length;
      el.innerHTML = '<span class="hoad-rating-badge__stars">' + estrelas(media) + '</span>' +
        '<span class="hoad-rating-badge__text">' + media.toFixed(1).replace('.', ',') + ' (' + notas.length + ')</span>';
      el.hidden = false;
      var nativo = el.parentNode.querySelector('.jdgm-preview-badge');
      if (nativo) nativo.style.display = 'none';
    }).catch(function () { /* mantém o selo nativo */ });
  }

  function boot() {
    document.querySelectorAll('[data-hoad-rating-badge]').forEach(function (el) {
      if (!el.__hoadRating) { el.__hoadRating = true; init(el); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
